import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Avatar } from 'antd';
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  DownloadOutlined,
} from '@ant-design/icons';

import moment from 'moment';

import { dateFormat } from 'utils/dates';
import { getAge } from 'utils/functions';
import UserActions from '../user-actions';
import UploadDBS from './upload-dbs';

const columns = [
  {
    title: 'Title',
    dataIndex: ['info', 'title'],
  },
  {
    title: 'Avatar',
    dataIndex: ['info', 'photoURL'],
    render: (text, record) => (
      <Link to={`/worker-detail/${record.id}`}>
        <Avatar src={text} />
      </Link>
    ),
  },
  {
    title: 'First Name',
    dataIndex: ['info', 'firstName'],
    render: (text, record) => (
      <Link to={`/worker-detail/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: 'Last Name',
    dataIndex: ['info', 'lastName'],
    render: (text, record) => (
      <Link to={`/worker-detail/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: 'Email',
    dataIndex: ['info', 'email'],
    render: (text) => <a href={`mailto:${text}`}>{text}</a>,
  },
  {
    title: 'Gender',
    dataIndex: ['info', 'gender'],
  },
  {
    title: 'Nationality',
    dataIndex: ['info', 'nationality'],
  },
  {
    title: 'Phone',
    dataIndex: ['info', 'mobilePhone'],
  },
  {
    title: 'Age',
    dataIndex: ['info', 'dateOfBirth'],
    render: (text) => <span>{getAge(text, moment())}</span>,
  },
  {
    title: 'DOB',
    dataIndex: ['info', 'dateOfBirth'],
    key: 'DOB',
    render: (value) => <span>{moment(value).format(dateFormat)}</span>,
  },
  {
    title: 'Profile Complete',
    dataIndex: 'isProfileComplete',
    render: (text) =>
      text ? (
        <CheckCircleTwoTone twoToneColor="#52c41a" />
      ) : (
        <CloseCircleTwoTone twoToneColor="#eb2f96" />
      ),
  },
  {
    title: 'Actions',
    dataIndex: 'id',
    render: (value, record) => <UserActions id={value} record={record} />,
  },
];

export const subColumns = [
  {
    title: 'DBS ID',
    dataIndex: ['certificateDBS', 'id'],
  },
  {
    title: 'Permission to check DBS',
    dataIndex: ['certificateDBS', 'permissionToCheckDBS'],
    render: (text) =>
      text ? (
        <CheckCircleTwoTone twoToneColor="#52c41a" />
      ) : (
        <CloseCircleTwoTone twoToneColor="#eb2f96" />
      ),
  },
  {
    title: 'DBS certificate',
    dataIndex: ['certificateDBS', 'fileURL'],
    render: (value) => {
      if (!value) return null;
      return (
        <Button
          target="_blank"
          href={value}
          type="primary"
          icon={<DownloadOutlined />}
          size="small"
        >
          Download
        </Button>
      );
    },
  },
  {
    title: 'Change DBS information',
    dataIndex: 'id',
    render: (value, record) => {
      return <UploadDBS {...record} />;
    },
  },
];

export default columns;
